import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from "@angular/router";
import { AccountService, AlertService } from '@app/_services';
declare var $: any;

@Component({
  selector: 'app-change-password',
  templateUrl: 'changepassword.component.html'
})
export class ChangePasswordComponent {
  form: FormGroup;
  loading: boolean = false; 
  IsPasswordChecker: boolean = false;
  errorMsg: string = '';
  tbxConfirmPwd: string = '';
  strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
  IsPwdValid: boolean = true;
  spnReqPassword: boolean = false;
  spnReqConfirmPassword: boolean = false;
  spnConfirmPassword: boolean = false;
  constructor(
    private formBuilder: FormBuilder,
    private activeModal: NgbActiveModal,
    private AccountService: AccountService,
    private alertService: AlertService,
    private router: Router,
  )
  {    
   
  }
  ngOnInit() {
   
    this.form = this.formBuilder.group({
      OldPassword: ['', Validators.required],
      NewPassword: ['', Validators.required],
      confirmPassword: ['', Validators.required]
    });
    $('#OldPassword').focus();
  }





  onblurRequiredConfirmPassword() {
    var txtbxNewPwd = $.trim(this.form.value.NewPassword);
    var txtbxConfirmPwd = $.trim(this.form.value.confirmPassword);
    if (txtbxConfirmPwd == "" || txtbxConfirmPwd == undefined) {
      this.spnReqConfirmPassword = true;
      this.spnConfirmPassword = false;
      //this.spnConfirmPasswordLength = false;
      $('#tbxConfirmPwd').css("border", "1px solid #F73D3D");
    }
    else if (txtbxNewPwd != txtbxConfirmPwd) {
      this.spnReqConfirmPassword = false;
      //this.spnConfirmPasswordLength = false;
      this.spnConfirmPassword = true;
      $('#tbxConfirmPwd').css("border", "1px solid #F73D3D");
    }
    else {
      this.spnReqConfirmPassword = false;
      this.spnConfirmPassword = false;
      //this.spnConfirmPasswordLength = false;
      $('#tbxConfirmPwd').css("border", "1px solid #86898C");
    }
  }

  onblurRequiredPassword() {
    var txtbxNewPwd = $.trim(this.form.value.NewPassword);
    var txtbxConfirmPwd = $.trim(this.form.value.confirmPassword);

    if (txtbxNewPwd == "" || txtbxNewPwd == undefined) {
      //this.spnPasswordLength = false;
      this.spnReqPassword = true;
      $('#NewPassword').css("border", "1px solid #F73D3D");
    }
    else if (!this.strongRegex.test(txtbxNewPwd)) {//if (this.tbxPwd.length < 7) {
      //this.spnPasswordLength = true;
      this.spnReqPassword = false;
      this.IsPwdValid = false;
      $('#NewPassword').css("border", "1px solid #F73D3D");
    }
    else {
      //this.spnPasswordLength = false;
      this.spnReqPassword = false;
      this.IsPwdValid = true;
      $('#NewPassword').css("border", "1px solid #86898C");
    }
    if (txtbxConfirmPwd != "") {
      this.onblurRequiredConfirmPassword();
    }

  }
  FocusNewPassword(e) {
    var txtbxNewPwd = $.trim(e.target.value);
    if (txtbxNewPwd != "") {
      if (!this.strongRegex.test(txtbxNewPwd)) { //check number of charecter
        this.IsPwdValid = false;
      }
      else
        this.IsPwdValid = true;
    }
    else
      this.IsPwdValid = false;
  }
  KeyUp_ValidChangePasswordFields(e) {
    var txtbxNewPwd = $.trim(e.target.value);
    if (txtbxNewPwd == "")
      this.IsPwdValid = false;
  }
  


  oldPassWordExist() {
    this.errorMsg = '';
  }
  
  onSubmit() {
    var uid = sessionStorage.getItem("uId")
    this.loading = true;
    this.alertService.clear();
    let params = {
      UserUID: uid,
      OldPassword: this.form.value.OldPassword,
      NewPassword: this.form.value.NewPassword  
    }
    this.AccountService.ChangePassword(params).subscribe(res => {
      this.loading = false;
      if (res && res.status == true) {        
        this.form.reset();
        this.activeModal.close();
        this.alertService.success(res.message);
      }
      else {       
        //this.alertService.error(res.message);
        this.errorMsg = res.message;
      }
    }, error => {      
      this.alertService.error("unknown error");
      this.loading = false;
    });

  }

  passwordMatchValidator() {
    if (this.form.value.confirmPassword == null || this.form.value.confirmPassword == "") {
      this.IsPasswordChecker = false;
    }
    if (this.form.value.confirmPassword) {
      if (this.form.value.NewPassword == this.form.value.confirmPassword) {
        this.IsPasswordChecker = false;
      }
      else {

        this.IsPasswordChecker = true;
      }
    }
  }
  onCloseDialog() {
    this.activeModal.close();
  }
}



